var variables = {

// Navigationheader / Navigationskopf
logo_bild: "Logo.png",
navigations_titel: "TT-Freunde",


// Startseite:
startseite_ueberschrift: "Tischtennisfreunde des TSV Poppenhausen 1910 e.V. (Ufr) ",
startseiten_bild: "tt_banner_header_new.png",


//Unsere Motivation
motivation_aktiv: true,

motivation_text_ueberschrift: "Unsere „Motivation“",
motivation_text_absatz1: "Tischtennis gilt als Sport und Spiel der Flexiblen und Kreativen in jeder Altersklasse und mit geringem Verletzungsrisiko. Neben den verschiedenen Schlagtechniken werden zusätzlich Koordination, Reaktionsfähigkeit, Konzentrationsfähigkeit, Schnelligkeit, Taktik und mentale Stärke im Wettkampf trainiert.",
motivation_text_absatz1_fett: "",

motivation_text_absatz2_1: "Daher treffen wir (und Gäste) uns in gemischten Gruppen immer donnerstags in der Wernthalhalle Poppenhausen.",

motivation_text_absatz2_2: "Trainiert und gespielt wird aktuell an 8 TT-Platten und bei Bedarf an unserem Butterfly TT-Roboter.",

motivation_text_absatz3_1: "Interessierte Erwachsene können uns gerne donnerstags ab 18:30 Uhr besuchen und 'schnuppern'.",

motivation_text_absatz4_1: "Da wir i.d.R. immer eine TT-Platte zwischen 18:30 - 20:00 Uhr frei haben, sind auch Gastspieler (anderer Vereine) willkommen. Ggf. kurze Info via WhatsApp über den Kontakt.",
// Da wir im Jugendbereich schon viele aktive Spieler haben, wäre es prima, wenn Ihr bereits erste Tischtennis-Fertigkeiten besitzt (z.B. kann der Ball auf dem Schläger ca. 5x nach oben getippt/ gespielt werden. Abwechselnd Vor-und Rückhand).

// Trainingszeiten:
trainingszeiten_aktiv: true,

trainingszeiten_ueberschrift: "Trainingszeiten 2026 in der Werntalhalle in Poppenhausen",
trainingszeiten_unterueberschrift: "(In den Schulferien ist kein Training, da die Werntalhalle geschlossen ist)",

trainingszeiten_absatz1_ueberschrift: "Jugendmannschaft Bezirksklasse Ufr-Nord:",
trainingszeiten_absatz1_text: "Donnerstag von 17:00 - 18:30 Uhr",

trainingszeiten_absatz2_ueberschrift: "Jugend- & Erwachsenen - Freizeitgruppe:",
trainingszeiten_absatz2_text: "Donnerstag von 18:30 - 20:00 Uhr",

trainingszeiten_bild: "BildTurnhalle.jpeg",


// Aktuelles:
aktuelles_aktiv: false,

aktuelles_card1_aktiv: false,
aktuelles_card1_ueberschrift: "TT-Meister in der Winterrunde 2024 !",
aktuelles_card1_unterueberschrift: "Stolz können die TT-Jungs der 2. Mannschaft sein, die sich den 1. Platz im letzten Runden-Spiel zurückeroberten",
aktuelles_card1_bild: "1_Platz_PH2_Winter2024.jpg",
aktuelles_card1_text: "",

aktuelles_card2_aktiv: false,
aktuelles_card2_ueberschrift: "TT-Meister in der Winterrunde in der BKB Ufr-Nord 2024 !",
aktuelles_card2_unterueberschrift: "Stolz können die TT-Jungs der 1. Mannschaft sein, die sich den 1. Platz im letzten Runden-Spiel zurückeroberten",
aktuelles_card2_bild: "MeisterVRHerbst2024.jpg",
aktuelles_card2_text: "Aufstieg in die BKA UFR-Nord zur RR 2025",

aktuelles_card3_aktiv: false,
aktuelles_card3_ueberschrift: "Aktuelles vom TSV Poppenhausen :",
aktuelles_card3_unterueberschrift: "Wieder neu aufgelegt: Unser Kabarett-Event im März 2025.",
aktuelles_card3_bild: "Krebs30032025.jpg", 
aktuelles_card3_text: "Wolfgang Krebs: BAVARIA FIRST!",


// PDF_Bild-Anzeige Home (wenn home_aktiv = true, dann anzeige in Home; wenn home_pdf true, dann pdf statt Bild aktiv)
pdf_bild_anzeige_home_aktiv: false,
pdf_bild_anzeige_home_pdf: false,
pdf_bild_anzeige_home_titel: "Banner",
pdf_bild_anzeige_home_src: "Bilder/TischtennisfreundeBanner.jpeg",
pdf_bild_anzeige_home_button: "Bild öffnen",


// PDF_Bild-Anzeige TSV (wenn home_aktiv = true, dann anzeige in Home; wenn home_pdf true, dann pdf statt Bild aktiv)
pdf_bild_anzeige_tsv_aktiv: false,
pdf_bild_anzeige_tsv_pdf: false,
pdf_bild_anzeige_tsv_titel: "TT-Tunierplan 2024 - Bezirk Ufr-Nord",
pdf_bild_anzeige_tsv_src: "UfrN_Terminplan_2024.pdf",
pdf_bild_anzeige_tsv_button: "als PDF öffnen",


// Bilder ( Fehler: u.g.  Bilder fehlen noch ....):
bilder_aktiv: true,

bilder_bild1_aktiv: false,
bilder_bild1_source: "Open1.jpg",

bilder_bild2_aktiv: true,
bilder_bild2_source: "Open2.jpg",

bilder_bild3_aktiv: true,
bilder_bild3_source: "Open3.jpg",

bilder_bild4_aktiv: true,
bilder_bild4_source: "Open4.jpg",


// Lernvideos:
lernvideos_aktiv: true,

lernvideos_video1_aktiv: true,
lernvideos_video1_source: "https://www.youtube-nocookie.com/embed/OKmWqc8ae_A", //Wichtig! -nocookie verwenden

lernvideos_video2_aktiv: true,
lernvideos_video2_source: "https://www.youtube-nocookie.com/embed/fIctD4igiIg" , //Wichtig! -nocookie verwenden

lernvideos_video3_aktiv: true,
lernvideos_video3_source: "https://www.youtube-nocookie.com/embed/PZBbbDV7uO8", //Wichtig! -nocookie verwenden

lernvideos_video4_aktiv: true,
lernvideos_video4_source: "https://www.youtube-nocookie.com/embed/L50n1iscvOs",


// Kontakt:
kontakt_aktiv: true,

kontakt_name: "Lutz Urlau",
kontakt_tel: "015123260710",
kontakt_mail: "tt.poppenhausen@outlook.de",

// TSV Gruss:
tsvGruss_aktiv: true,


// Rückblick:
rueckblick_aktiv: true,
rueckblick_cards:[
    {
        ueberschrift: "TT-Bundesliga-Feeling in Bad Königshofen.",
        unterueberschrift: "25.11.2023",
        text: "Besuch mit 15 Kids und 11 Erwachsenen des TTBL Match TSV Bad Königshofen gegen TTC Schwalbe Bergneustadt. Einer der Höhepunkte war das Einlaufen unserer Kids vor dem Match mit den TTBL-Spielern vor 619 Zuschauern.",
        bild: "TTBLKönigshofen 25112023.jpg"
    },

    {
        ueberschrift: "Erfolgreicher Auftakt in unsere erste Saison in der Bezirksklasse B, Gruppe 1 Nordost Herbst 2023 (BTTV - Unterfranken-Nord, Jugend 19 (3er)) ",
        unterueberschrift: "05.10.2023",
        text: "Unsere Jungs durften -gemäß Braunschweiger Spielsystem- an diesem Tag 2 Doppel- und 8 Einzel-Matches gegen den HV Burglauer IV bestreiten. Am Ende stand es 8:2 für Poppenhausen.",
        bild: "Spielstandam07102023.jpg"
    },
       {
        ueberschrift: "Tischtennis-Werntal-Cup 2023 (Jugend & Erwachsene) in der Werntalhalle Poppenhausen ",
        unterueberschrift: "Samstag, 2. September 2023",
        text: "Die sportlich anspruchsvolle und zwanglos fröhliche Saisonvorbereitung kam bei den Teilnehmern sehr gut an und die zu erwartende Mund-zu-Mund-Propaganda sollte eine gute Grundlage für den nächsten Werntal-Cup sein. Der findet am 7. September 2024 statt. 10 Jugendliche bis 12 Jahre aus 4 Vereinen kämpften mit den kleinen schnellen Ball um die vorderen Plätze. Platz 1 belegte der SV Langendorf, Platz 2 & 3 die TT Freunde aus Poppenhausen mit Elias Schmitt und Max Preuske.",
        bild: "Jugend_Werntalcup_2023.jpg"
    },
    {
        ueberschrift: "Kids Open Tuniere in Langendorf und Schwanfeld",
        unterueberschrift: "25.06.2023 & 16.07.2023",
        text: "Elias Schmitt und Leo Göbel teilten sich den 1. & 2. Platz der Jahrgänge 2011-2012 in Langendorf. Max Preuske holte sich den 1. Platz im Jahrgang 2010 in Schwanfeld",
        bild: "RückblickTTLangendorf.jpg"
    },
    {
        ueberschrift: "Kids Open des TT-Bezirks Ufr.-Nord in der Werntalhalle",
        unterueberschrift: "13.05.2023",
        text: "Bei diesem Tischtennisturnier spielten 61 Kinder der Jahrgänge 2010 und jünger gegeneinander. Im Jahrgang 2013 konnte Mathis Lehmeyer den erfolgreichen 3. Platz (von 8 Teilnehmern) erreichen. Ebenso erreichte Elias Schmitt den 3. Platz (von 12 Teilnehmern). Unsere anderen Jungs und Mädels erkämpften sich i.d.R. Platzierungen in der vorderen Hälfte.",
        bild: "Rueckblick4.jpg"
    },
    {
        ueberschrift: "Tag der offenen Tür in der Werntalhalle",
        unterueberschrift: "29.04.2023 von 14:00 - 16:00 Uhr",
        text: " Vorstellung der Tischtennisabteilung, der Ausrüstung und Angebote zum TT spielen",
        bild: "Rueckblick1.jpg"
    },
    {
        ueberschrift: "Unsere neuen TT-Platten",
        unterueberschrift: "15.04.2023",
        text: "Unsere neuen DONIC TT-Platten sind da! Somit ist unser Ziel von 7 neuen TT-Platten erreicht!. Dafür ein herzliches Dankeschön an unsere TT-Freunde, Gönner und Riedel-Bau.",
        bild: "Rueckblick2.jpg"
    },
    {
        ueberschrift: "Unsere TT-Hompage wurde online gestellt",
        unterueberschrift: "22.02.2023",
        text: "Dafür ein herzliches Dankeschön an Sebastian Pfülb. Die Homepage wurde durch Sebastian eigenständig konzipiert und via HTML und CCS in Visual Studio entwickelt. Herausheben möchten wir die tolle Beratung bei der Ausgestaltung, das fachliche Wissen und der unkomplizierte Support bei der Adminstration der Webseite.",
        bild: "Rueckblick3.jpg"
    },
],


// Ueber den TSV:
ueberDenTSV_aktiv: true,
  
  
}

export default variables;
